var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.datas)?_c('K-Loading',{attrs:{"Loading":_vm.Loading}}):_c('div',[_c('section',{staticClass:"box"},[_c('div',{staticClass:"main"},[_c('p',{staticClass:"cn"},[_vm._v("本產品為正品，請放心使用")]),_vm._v(" "),_c('p',{staticClass:"en"},[_vm._v("This product is genuine, please rest assured to use it")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67a7d6c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Normal18.vue
// module id = null
// module chunks = 